import type { ReactNode } from 'react';
import ClusterViewModeSwitcher from '@/app/KeywordResearch/components/keyword-clustring/components/ClusterViewModeSwitcher';
import { TabHelpButton } from './SectionHelpDrawer';

export type OverviewTab = 'summary' | 'comparison';

export function OverviewTabSwitch({
  value,
  onChange,
  aside,
}: {
  value: OverviewTab;
  onChange: (next: OverviewTab) => void;
  /** Controls on the physical left (e.g. range select). */
  aside?: ReactNode;
}) {
  return (
    <div className="workspace-mode-wrap workspace-mode-wrap--with-aside">
      {aside ? (
        <div className="workspace-mode-aside">{aside}</div>
      ) : null}
      <ClusterViewModeSwitcher
        value={value}
        onChange={(id) => onChange(id as OverviewTab)}
        aria-label="بخش‌های نمای کلی"
        modes={[
          {
            id: 'summary',
            icon: 'speedometer2',
            label: (
              <>
                خلاصه وضعیت
                <TabHelpButton guideKey="overview-summary" />
              </>
            ),
          },
          {
            id: 'comparison',
            icon: 'shuffle',
            label: (
              <>
                مقایسه
                <TabHelpButton guideKey="overview-comparison" />
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
